var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.group.slots.length > 0),expression:"group.slots.length > 0"}]},[_c('select-menu',{attrs:{"text":_vm.text,"values":_vm.values},model:{value:(_vm.local),callback:function ($$v) {_vm.local=$$v},expression:"local"}},[_vm._v("\n        Zeitraum\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }